
import React, { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { agrogestao } from '@/api/agrogestaoClient';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowUpCircle, ArrowDownCircle, Wallet, FileText, CreditCard } from "lucide-react";
import { Link } from 'react-router-dom';
import ControleBancario from '@/components/financeiro/ControleBancario';

export default function Financeiro() {
  const propriedadeId = localStorage.getItem("propriedade_selecionada");

  if (!propriedadeId) return <div className="p-8 text-center text-stone-500">Selecione uma propriedade</div>;

  return (
    <div className="space-y-8">
      {/* Quick Actions Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pb-6 border-b border-stone-200">
        <div>
          <h1 className="text-3xl font-bold text-stone-900 tracking-tight">Financeiro</h1>
          <p className="text-stone-500 mt-1">Gestão de contas e conciliação bancária</p>
        </div>
        <div className="flex gap-3">
          <Link to="/ContasReceber">
            <Button variant="outline" className="text-emerald-700 border-emerald-200 hover:bg-emerald-50 hover:text-emerald-800 gap-2">
              <ArrowUpCircle className="w-4 h-4" />
              Receitas
            </Button>
          </Link>
          <Link to="/ContasPagar">
            <Button variant="outline" className="text-rose-700 border-rose-200 hover:bg-rose-50 hover:text-rose-800 gap-2">
              <ArrowDownCircle className="w-4 h-4" />
              Despesas
            </Button>
          </Link>
          <Link to="/Relatorios">
            <Button variant="outline" className="text-stone-700 border-stone-200 hover:bg-stone-50 gap-2">
              <FileText className="w-4 h-4" />
              Relatórios
            </Button>
          </Link>
        </div>
      </div>

      {/* Main Bank Control Module */}
      <ControleBancario />

      {/* Footer Info */}
      <div className="bg-blue-50/50 p-4 rounded-lg flex items-start gap-3 border border-blue-100">
        <div className="bg-blue-100 p-2 rounded-full text-blue-600">
          <Wallet className="w-5 h-5" />
        </div>
        <div>
          <h4 className="font-semibold text-blue-900 text-sm">Integração Automática</h4>
          <p className="text-blue-700/80 text-xs mt-1">
            Ao dar baixa em "Contas a Pagar" ou "Receber", selecione a conta bancária para que o saldo seja atualizado e o extrato gerado automaticamente.
          </p>
        </div>
      </div>
    </div>
  );
}
